"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DisclaimerComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _uxcore = require("@ux/uxcore2");
var _storeProvider = require("./../util/storeProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class DisclaimerComponent extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };
  }
  render() {
    const {
      disclaimerLinkText = '',
      disclaimerTitle = '',
      disclaimerContent = ''
    } = this.props;
    if (!disclaimerLinkText || !disclaimerContent) return null;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_uxcore.Button, {
      className: "disclaimer-link",
      "aria-haspopup": "true",
      design: "inline",
      onClick: () => {
        this.setState({
          modal: true
        });
      },
      text: disclaimerLinkText
    }), this.state.modal && /*#__PURE__*/React.createElement(_uxcore.Modal, {
      title: disclaimerTitle,
      onClose: () => {
        this.setState({
          modal: false
        });
      }
    }, /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: disclaimerContent
      }
    })));
  }
}
exports.DisclaimerComponent = DisclaimerComponent;
DisclaimerComponent.propTypes = {
  disclaimerLinkText: _propTypes.default.string,
  disclaimerTitle: _propTypes.default.string,
  disclaimerContent: _propTypes.default.string
};
var _default = exports.default = (0, _storeProvider.provideContext)(DisclaimerComponent);